import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

// *load ข้อมูล service active log
function* loadServiceActiveLog(action) {
  const {
    data: { page, pageSize, orderBy, orderType, filterObj, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/service-active-log/load-data`,
      {
        page,
        pageSize,
        orderBy,
        orderType,
        filterObj,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.loadServiceActiveLog.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadServiceActiveLog.failure())
  }
}

export default function* watchServiceActiveLog() {
  yield all([
    takeEvery(actions.LOAD_SERVICE_ACTIVE_LOG.REQUEST, loadServiceActiveLog),
  ])
}
export { loadServiceActiveLog }
